export enum FreeDaysMarkingEnum {
  DAY_OFF_FOR_5_DAY_WORKWEEK = 'dayOffFor5DayWorkweek',
  SUNDAY = 'sunday',
  DAY_OFF_FOR_SUNDAY = 'dayOffForSunday',
  HOLIDAY = 'holiday',
  DAY_OFF_FOR_HOLIDAY = 'dayOffForHoliday',
  SCHEDULED_DAY_OFF = 'scheduledDayOff',
}
